import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents';
import { debounce } from '../../utilities/functions';

import { Base } from './Base';

const classes = {
  hit: 'hit'
};

export class ScrollHandler extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.subscriptions = [];
    this.scrollTop = 0;
    this.direction = 'down';
    this.init();
  }

  init() {
    this.bindAddSubcriptionListener();
    this.bindRemoveSubcriptionListener();
    this.bindScrollHandler();
    this.bindResizeHandler();
  }

  bindAddSubcriptionListener() {
    this.addSubscriptionHandler = this.handleAddSubscriptions.bind(this);
    window.addEventListener(events.ADD_SCROLL_SUBSCRIPTION, this.addSubscriptionHandler);
  }

  bindRemoveSubcriptionListener() {
    this.removeSubscriptionHandler = this.handleRemoveSubscriptions.bind(this);
    window.addEventListener(events.REMOVE_SCROLL_SUBSCRIPTION, this.removeSubscriptionHandler);
  }

  handleAddSubscriptions(e) {
    const { eventName, selector } = e.detail;

    if (eventName && selector) {
      const elements = document.querySelectorAll(selector);

      elements.forEach((element) => {
        this.subscriptions.push({
          element: element,
          eventName: eventName
        });
      });
    }
  }

  handleRemoveSubscriptions(e) {
    const { eventName, selector } = e.detail;

    let indexes = [];

    if (eventName && selector) {
      const elements = Array.from(document.querySelectorAll(selector));

      this.subscriptions.forEach((subscription, i) => {
        if (elements.indexOf(subscription.element) > -1 && subscription.eventName === eventName) {
          indexes.push(i);
        }
      });

      for (let i = indexes.length - 1; i >= 0; i--) {
        this.subscriptions.splice(indexes[i], 1);
      };
    }
  }

  bindScrollHandler() {
    this.scrollHandler = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.scrollHandler, { passive: true });
  }

  handleScroll() {
    this.updateScrollTop();
    this.updateSubscriptions();
  }

  updateScrollTop() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop < this.scrollTop) {
      this.direction = 'up';
    } else {
      this.direction = 'down';
    }

    this.scrollTop = scrollTop;
  }

  bindResizeHandler() {
    this.resizeHandler = debounce(() => {
      this.updateSubscriptions();
    }, 250);

    window.addEventListener('resize', this.resizeHandler);
  }

  handleResize() {
    this.updateSubscriptions();
  }

  updateSubscriptions() {
    this.subscriptions.forEach((subscription) => {
      const { eventName, element } = subscription;

      if (eventName && element) {
        if (!element.classList.contains(classes.hit) && element.getBoundingClientRect && element.getBoundingClientRect().top < 0) {
          element.classList.add(classes.hit);

          dispatchEvent(element, eventName, {
            direction: 'down'
          });
        }

        if (element.classList.contains(classes.hit) && element.getBoundingClientRect().top > 0) {
          element.classList.remove(classes.hit);

          dispatchEvent(element, eventName, {
            direction: 'up'
          });
        }
      }
    });
  }

  cleanup() {
    window.removeEventListener(events.ADD_SCROLL_SUBSCRIPTION, this.addSubscriptionHandler);
    window.removeEventListener(events.REMOVE_SCROLL_SUBSCRIPTION, this.removeSubscriptionHandler);
    window.removeEventListener('scroll', this.scrollHandler);
    window.removeEventListener('resize', this.resizeHandler);
  }
}
